import { PermissionFeature, PermissionMatrix, PermissionType } from '@shared/const';
import { Role } from '@interfaces/models';

import { useCurrentUser } from './use-current-user';

export const useHasPermission = (
  permissionFeature: PermissionFeature,
  permissionType: PermissionType,
  forRole?: Role,
): boolean => {
  const { role } = useCurrentUser();

  const permissionsList = PermissionMatrix[permissionFeature][permissionType];
  if (!role || !permissionsList) return false;

  // If forRole is provided, check if it is in the list of allowed roles
  if (forRole) return permissionsList.includes(forRole);

  // If forRole is not provided, check if the users's role is in the list of allowed roles
  return permissionsList.includes(role);
};
